import { useLogin } from '@refinedev/core';

import { ThemedTitleV2 } from '@refinedev/antd';
import { Layout, Space, Button } from 'antd';

export const Login: React.FC = () => {
  const { mutate: login } = useLogin();

  return (
    <Layout
      style={{
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Space direction="vertical" align="center">
        <ThemedTitleV2
          collapsed={false}
          wrapperStyles={{
            fontSize: '22px',
            marginBottom: '36px',
          }}
        />
        <Button onClick={login}>ログイン</Button>
      </Space>
    </Layout>
  );
};
